export const AUTH_USER_ACTION_TYPES = {
  SET_CURRENT_USER: 'auth_user/SET_CURRENT_USER',
  RESET_CURRENT_USER: 'auth_user/RESET_CURRENT_USER',
};
